import { useState, useEffect } from "react";
import { T } from "../../config/theme.js";
import { Btn } from "../ui/index.jsx";
import { X } from "lucide-react";

// ── 체험 종료 배너 (D-7, D-3) ──
export function TrialExpiryBanner({ token, plan, planExpiresAt, goPricing }) {
  const [dismissed, setDismissed] = useState(false);

  // ★ FIX: useEffect를 모든 early return보다 앞으로 이동 (#310 해결)
  const today = new Date().toISOString().slice(0, 10);
  const dismissKey = `pause_trial_banner_dismissed_${today}`;

  useEffect(() => {
    if (localStorage.getItem(dismissKey)) setDismissed(true);
  }, [dismissKey]);

  // ── 여기서부터 early return 가능 ──
  if (!planExpiresAt || plan === "free") return null;

  const now = new Date();
  const expires = new Date(planExpiresAt);
  const daysLeft = Math.ceil((expires - now) / (1000 * 60 * 60 * 24));

  // 7일 또는 3일일 때만 표시
  if (daysLeft > 7 || daysLeft < 1 || (daysLeft > 3 && daysLeft < 7)) return null;

  // 당일은 모달에서 처리
  if (daysLeft <= 0) return null;

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(dismissKey, "true");
  };

  const message = daysLeft <= 3
    ? "Core 체험이 3일 후 종료됩니다. 유지하고 싶은 기능이 있다면 플랜을 확인해 주세요."
    : "Core 체험이 7일 후 종료됩니다. 현재 사용 중인 기능은 종료 후 일부 제한될 수 있습니다.";

  return (
    <div style={{
      padding: "12px 18px", marginBottom: 16, borderRadius: 12,
      background: "#123A33", border: `1px solid ${T.accent}25`,
      display: "flex", justifyContent: "space-between", alignItems: "center",
      gap: 12,
    }}>
      <div style={{ fontSize: 13, color: "#9FD5C7", lineHeight: 1.5, flex: 1 }}>
        {message}
      </div>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
        <Btn variant="ghost" style={{ fontSize: 11, padding: "6px 14px", borderColor: T.accent + "40", color: T.accent }}
          onClick={goPricing}>플랜 보기</Btn>
        <button onClick={handleDismiss} style={{
          background: "none", border: "none", color: "#9FD5C7", cursor: "pointer",
          padding: 4, opacity: 0.6,
        }}>
          <X size={16} />
        </button>
      </div>
    </div>
  );
}

// ── 체험 종료 당일 모달 (1회성) ──
export function TrialExpiryModal({ plan, planExpiresAt, goPricing }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!planExpiresAt || plan === "free") return;

    const now = new Date();
    const expires = new Date(planExpiresAt);
    const daysLeft = Math.ceil((expires - now) / (1000 * 60 * 60 * 24));

    if (daysLeft > 0) return;

    const today = new Date().toISOString().slice(0, 10);
    const modalKey = `pause_trial_modal_shown_${today}`;
    if (localStorage.getItem(modalKey)) return;

    setShow(true);
    localStorage.setItem(modalKey, "true");
  }, [planExpiresAt, plan]);

  if (!show) return null;

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      background: "rgba(0,0,0,0.7)", backdropFilter: "blur(8px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20,
    }}>
      <div style={{
        background: T.card, border: `1px solid ${T.border}`, borderRadius: 20,
        padding: "36px 32px", maxWidth: 400, width: "100%", textAlign: "center",
      }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: T.text, marginBottom: 12 }}>
          Core 체험이 종료되었습니다
        </div>
        <div style={{ fontSize: 14, color: T.textDim, lineHeight: 1.7, marginBottom: 28 }}>
          오늘부터 Free 플랜 기준으로 전환됩니다.<br />
          일부 기능이 제한될 수 있습니다.
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
          <Btn variant="primary" onClick={() => { setShow(false); goPricing?.(); }}>
            플랜 보기
          </Btn>
          <Btn variant="ghost" onClick={() => setShow(false)}>
            나중에
          </Btn>
        </div>
      </div>
    </div>
  );
}
